import { CheckCircle, Users, Award, Target } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { companyInfo } from '../data/mock';

export const Sobre = () => {
  const values = [
    {
      icon: CheckCircle,
      title: 'Qualidade Garantida',
      description: 'Produtos originais com certificação e garantia de fábrica'
    },
    {
      icon: Users,
      title: 'Atendimento Personalizado',
      description: 'Equipe especializada pronta para ajudar você'
    },
    {
      icon: Award,
      title: 'Experiência Comprovada',
      description: 'Mais de 15 anos servindo profissionais e amadores'
    },
    {
      icon: Target,
      title: 'Compromisso',
      description: 'Sua satisfação é nossa prioridade'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section com Banner */}
      <section
        className="relative h-[500px] flex items-center justify-center overflow-hidden"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_6b1a5697-2bbc-40cc-b4c0-7a1eda2428bd/artifacts/12g1uap0_Imagem%20do%20WhatsApp%20de%202025-11-29%20a%CC%80%28s%29%2015.35.44_35741ba4.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        <div className="container mx-auto px-4 text-center text-white relative z-10">
          <h1 className="text-5xl md:text-7xl font-black mb-6 drop-shadow-2xl">
            Sobre a Casa das Ferramentas
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Referência em máquinas e ferramentas profissionais em Canaã dos Carajás
          </p>
        </div>
      </section>

      {/* Company Description */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Card className="shadow-xl">
              <CardContent className="p-8 md:p-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Nossa História</h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  {companyInfo.about}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                  <div className="text-center p-6 bg-blue-50 rounded-lg">
                    <div className="text-4xl font-bold text-blue-900 mb-2">STIHL</div>
                    <div className="text-gray-700">Distribuidor Autorizado</div>
                  </div>
                  <div className="text-center p-6 bg-red-50 rounded-lg">
                    <div className="text-4xl font-bold text-red-900 mb-2">8+</div>
                    <div className="text-gray-700">Marcas Parceiras</div>
                  </div>
                  <div className="text-center p-6 bg-green-50 rounded-lg">
                    <div className="text-4xl font-bold text-green-900 mb-2">100%</div>
                    <div className="text-gray-700">Produtos Originais</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Nossos Valores</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <Card key={index} className="text-center hover:shadow-xl transition-shadow">
                  <CardContent className="p-8">
                    <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon className="text-white" size={32} />
                    </div>
                    <h3 className="text-xl font-bold mb-3">{value.title}</h3>
                    <p className="text-gray-600">{value.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 bg-gradient-to-r from-blue-900 to-blue-800 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold mb-4">Nossa Missão</h3>
                <p className="text-blue-100 leading-relaxed">
                  Fornecer máquinas e ferramentas profissionais de alta qualidade, com atendimento especializado 
                  que atende construtoras, marcenarias e profissionais de Canaã dos Carajás e região.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold mb-4">Nossa Visão</h3>
                <p className="text-blue-100 leading-relaxed">
                  Consolidar nossa posição como referência regional em máquinas e ferramentas profissionais, 
                  mantendo nossa tradição de atendimento especializado e parceria com as melhores marcas.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 bg-gradient-to-r from-blue-900 to-blue-800">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h2 className="text-3xl font-bold mb-6">Por Que Escolher a Casa das Ferramentas?</h2>
            <p className="text-lg text-blue-100 mb-8">
              Somos especializados em fornecer as melhores ferramentas e equipamentos para profissionais 
              e entusiastas. Nossa experiência garante que você sempre terá acesso aos produtos certos 
              para o seu trabalho.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-black text-red-500 mb-2">+500</div>
                <p className="text-blue-100">Produtos em estoque</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-black text-red-500 mb-2">+10</div>
                <p className="text-blue-100">Anos de experiência</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-black text-red-500 mb-2">+20</div>
                <p className="text-blue-100">Marcas parceiras</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
